export type MeetingServicePriceListsItem = Readonly<{
    id: number
    address?: {
        displayName?: string
    }
    displayName: string
    shop: {
        id: number
    }
    priceLists: MeetingServicePriceList[]
}>

export enum MeetingServicePriceListCategory {
    EXTERNAL = "EXTERNAL",
    INTERNAL = "INTERNAL",
}

export type MeetingServicePriceList = Readonly<{
    id: number
    displayName: string
    colorCode: string
    category: MeetingServicePriceListCategory
    isFavorite: boolean
}>

export type PriceListFavoriteItem = Readonly<{
    id: number
    priceList: {
        id: number
    }
}>
